<template>
  <div>
    <user-detail-title
        first-bread="售后服务"
        second-bread="售后服务修改"
        first-url="/user/service"
        title-name="售后服务修改"
    />
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="Clist.name" :placeholder="LookData.name" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="文件描述">
          <el-input v-model="Clist.description" :placeholder="LookData.description" :rows="10" type="textarea" style="width: 500px;"></el-input>
        </el-form-item>
        <el-button @click="handleChange">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ServiceChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
        Clist: {
          'id': this.$route.params.id,
          'name':null,
          'photoUrl':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.photoUrl=file.data;
      },
      GetLookData(id){
        this.$axios.get('/api/after/getById/',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      },
      handleChange(){
        if (this.Clist.name || this.Clist.photoUrl  || this.Clist.description ){
          this.$axios.post('/api/after/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.Clist= {
                'id': this.$route.params.id,
                'name':null,
                'photoUrl':null,
                'description':null,
              }//表示Change添加的数据,
              this.$message({
                message:'添加成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('请选择一项进行上传')
        }
      }
    },
  }
</script>

<style scoped>

</style>